<template >
  <boxDropDown title="Correção de dias duplicados">
    <template class="support-tools">

      <div class="form-group col-md-12 support-tools__warning">
        <span><b>Atenção: </b>Caso envie com nenhum colaborador adicionado, a correção de dias duplicados será feita para todos os colaboradores da empresa.</span>
      </div>

      <div class="form-group col-md-12">
        <label for="accountantEmail">ID da empresa</label>
        <input type="companyId" class="form-control" placeholder="ID da empresa" id="companyId" name="companyIdName" v-model="dataSend.companyId">
      </div>

      <div class="form-group col-md-6">
        <div class="input-group input-with-date">
          <label>Data Inicial</label>
          <datepicker  ref="duplicateDaysInitDate" v-model="dataSend.initDate" :language="ptBR"
            :format="customFormatter" placeholder="DD/MM/AAAA" />
          <i aria-hidden="true" style="pointer-events: none; top: 35px;">
            <ion-icon name="calendar"></ion-icon>
          </i>
        </div>
      </div>

      <div class="form-group col-md-6">
        <div class="input-group input-with-date">
          <label>Data Final</label>
          <datepicker ref="duplicateDaysEndDate" v-model="dataSend.endDate" :language="ptBR"
            :format="customFormatter" placeholder="DD/MM/AAAA" />
          <i aria-hidden="true" style="pointer-events: none; top: 35px;">
            <ion-icon name="calendar"></ion-icon>
          </i>
        </div>
      </div>

      <div class="form-group col-md-12">
        <label for="companyIdToAddAccountant">Insira o ID do(s) colaborador(es)</label>
        <input type="text" class="form-control" v-model="employeeId" placeholder="ID" id="companyIdToAddAccountant">
      </div>

      <div class="form-group col-md-12 text-center center">
        <div v-for="(item, index) in dataSend.employeeIds" :key="index" class="company-selected">
          <span class="company-selected__title">{{ item }}</span>
          <span class="company-selected__close" @click="removeEmployee(index)">
            <ion-icon name="close-outline"/>
          </span>
        </div>
      </div>

      <div class="form-group col-md-12 text-center full-width">
        <button class="btn btn-primary" @click="addEmployee()">Adicionar colaborador</button>
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" :disabled="isDisabled()" @click="sendData()">
          <span v-if="!loadingCheckDuplicatedDays">Corrigir dias</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import datepicker from "vuejs-datepicker";
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    CONTEXT_COMPANY,
    CHECK_DUPLICATED_DAYS,
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";

  export default {
    name: "duplicate-days",
    components: {
      boxDropDown,
      datepicker,
    },
    data() {
      return {
        ptBR,
        messageValidateFields: "",
        employeeId: "",
        dataSend: {
          companyId: "",
          initDate: "",
          endDate: "",
          employeeIds: []
        },
        loadingCheckDuplicatedDays: false,
        contentSetting: ""
      }
    },
    methods: {
      isDisabled(){
        return this.loadingCheckDuplicatedDays;
      },
      customFormatter(date) {
        const dateWithoutTime = moment(date).startOf('day').toDate();
        return moment(dateWithoutTime).format('DD/MM/YYYY');
      },
      addEmployee() {
        if (this.employeeId.trim().length !== 32) {
          this.messageValidateFields = "Id do colaborador é inválido";
          return;
        }

        if(this.dataSend.employeeIds.includes(this.employeeId)){
          this.messageValidateFields = 'O colaborador já está inserido na listagem';
          return
        }

        this.dataSend.employeeIds.push(this.employeeId);
        this.employeeId = "";
        this.messageValidateFields = "";
      },
      removeEmployee(index) {
        this.dataSend.employeeIds.splice(index, 1);        
      },
      validateFields() {
        if (this.dataSend.companyId.trim().length !== 32) {
          this.messageValidateFields = "Id da empresa é inválido";
          return false;
        }

        if (this.dataSend.initDate === "" || this.dataSend.endDate === "") {
          this.messageValidateFields = "Preencha os campos de data";
          return false;
        }

        if(this.dataSend.endDate < this.dataSend.initDate){
          this.messageValidateFields = "Data final não pode ser menor que a data inicial";
          return false;
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        let bodyRequest = {
          companyId: this.dataSend.companyId,
          userIds: this.dataSend.employeeIds,
          init: moment(this.dataSend.initDate).startOf('day').format(),
          end: moment(this.dataSend.endDate).startOf('day').format()
        };

        console.log(bodyRequest);

        this.loadingCheckDuplicatedDays = true;

        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.dataSend.companyId}`).then((response) => {
          this.contentSetting = response.data;
          let bodyRequestJSON = JSON.stringify(bodyRequest);

          REQUEST_SERVICE.requestContext('POST', CHECK_DUPLICATED_DAYS, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Dias duplicados normalizados com sucesso!", "success");
            this.clearFields();
            this.loadingCheckDuplicatedDays = false;
          }).catch((reason) => {
            this.loadingCheckDuplicatedDays = false;
            if(reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
            }
          });
        }).catch((reason) => {
          this.loadingCheckDuplicatedDays = false;
          ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de desenvolvimento", "error");
        });
      },
      clearFields(){
        this.employeeId = "";
        this.dataSend.companyId = "";
        this.dataSend.initDate = "";
        this.dataSend.endDate = "";
        this.dataSend.employeeIds = [];
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/duplicateDays.vue